<template>

  <table class="table table-borderless table-border">
    <thead>
      <tr>
        <th>Nome</th>
        <th>CNPJ</th>
        <th>IE</th>
        <th>IM</th>
        <th>UF</th>
        <th>E-mail</th>
        <th>Telefone</th>
        <th>Criado por</th>
        <th>Criado em</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="company in subsidiaries" :key="company.id">
        <td>{{ company.name | uppercase }}</td>
        <td>{{ company.cnpj | cnpj }}</td>
        <td>{{ company.ie }}</td>
        <td>{{ company.im }}</td>
        <td>{{ company.uf }}</td>
        <td>{{ company.email }}</td>
        <td>{{ company.phone }}</td>
        <td>{{ company.createdBy }}</td>
        <td>{{ company.createdAt | datetime }}</td>
        <td class="text-right">
          <button @click="$emit('sendSubsidiaryToEdit', company)" class="btn-icon btn-outline mr-2">
            <edit-icon size="1.5x"/>
          </button>
          <button v-if="$withPolicy('application', 'companies/delete')"
                  @click="$emit('sendSubsidiaryToDelete', company)"
                  class="btn-icon btn-outline-red mr-2">
            <trash-2-icon size="1.5x"/>
          </button>
        </td>
      </tr>
    </tbody>
  </table>

</template>

<script>
  import {Trash2Icon, EditIcon, } from 'vue-feather-icons'

  export default {
    components: { EditIcon, Trash2Icon },
    name: 'Table',
    props: {
      subsidiaries: { required: true, type: Array }
    }
  }
</script>

<style scoped>

</style>
